import { $cloud60, $greenStatus, $redStatus, $sky50 } from "../cssjs/colors";

export enum ResourceAvailabilityLabel {
  InUse = "In Use",
  Available = "Available",
  Operable = "Operable",
  Inoperable = "Inoperable",
  Unknown = "Unknown",
}

export enum ResourceAvailabilityLegendLabel {
  InUse = "In Use",
  Available = "Available / Operable",
  Inoperable = "Closed / Inoperable",
  Unknown = "Unknown",
}

export enum ResourceDisplayTitle {
  stands = "Stands",
  gates = "Gates",
}

export const ResourceAvailabilityColor: Record<
  ResourceAvailabilityLabel,
  string
> = {
  [ResourceAvailabilityLabel.InUse]: $sky50,
  [ResourceAvailabilityLabel.Available]: $greenStatus,
  [ResourceAvailabilityLabel.Operable]: $greenStatus,
  [ResourceAvailabilityLabel.Inoperable]: $redStatus,
  [ResourceAvailabilityLabel.Unknown]: $cloud60,
};
